import { NgModule } from '@angular/core';
import {
  FileModule,
  FileService,
  ZipService,
} from '@epicuro-next/ataraxia/file';
import { DataOrderBookModule } from '@epicuro-next/data/order-book';
import { I18nModule } from '@epicuro-next/platform/i18n';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import {
  OrderDetailsEffects,
  OrdersEffects,
  PlacedPeriodFilterEffects,
} from './state';
import { FiltersEffects } from './state/filters';
import { orderBookFeatureKey } from './state/prefix';
import { initialState, reducers } from './state/store';
import { resetStateMetaReducer } from '@epicuro-next/state/meta-reducers';

@NgModule({
  imports: [
    StoreModule.forFeature(orderBookFeatureKey, reducers, {
      metaReducers: [resetStateMetaReducer(initialState)],
    }),
    EffectsModule.forFeature([
      FiltersEffects,
      OrdersEffects,
      OrderDetailsEffects,
      PlacedPeriodFilterEffects,
      I18nModule,
    ]),
    DataOrderBookModule,
    FileModule,
  ],
  providers: [ZipService, FileService],
})
export class OrderBookStateModule {}
